import { Outlet } from "react-router-dom";
import CommonLayout from "../../pages/Layouts/CommonLayout";
import useSubAdmin from "./useSubAdmin";

const SubAdmin = () => {
  const { drawerMenu } = useSubAdmin();

  return (
    <CommonLayout drawerMenu={drawerMenu}>
      <Outlet />
    </CommonLayout>
  );
};

export default SubAdmin;
